var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaohaus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0E1235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3963 14.7144H14.0966V19.9852H19.3963V14.7144Z",
    fill: "#F2CF63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0832 14.1468H19.3829V9.16391H14.0832V14.1468Z",
    fill: "#6D94CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17729 14.1468H13.477V9.16391H8.17729V14.1468Z",
    fill: "#FE1D5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5637 14.1381C20.5637 11.229 22.9399 8.86719 25.8633 8.86719V14.1381H20.5637Z",
    fill: "#1A84DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4709 20.0002L31.7705 20.0002L31.7705 14.7293L26.4709 14.7293L26.4709 20.0002Z",
    fill: "#6D94CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5637 19.9996L25.8633 14.7144H20.5637V19.9996Z",
    fill: "#FE1D5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7824 14.1381C31.7824 11.229 29.4062 8.86719 26.4827 8.86719V14.1381H31.7824Z",
    fill: "#F2CF63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 25.8622C20.6641 22.9532 23.0403 20.5913 25.9638 20.5913V25.8622H20.6641Z",
    fill: "#1A84DD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6641 26.4385L25.9638 31.7237V26.4385H20.6641Z",
    fill: "#6D94CE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8682 31.7238C31.8682 28.8147 29.492 26.4529 26.5685 26.4529V31.7238H31.8682Z",
    fill: "#FE1D5B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3959 26.4385C19.3959 29.3475 17.0197 31.7093 14.0962 31.7093V26.4385H19.3959Z",
    fill: "#F2CF63"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17757 26.4385C8.17757 29.3475 10.5538 31.7093 13.4773 31.7093V26.4385H8.17757Z",
    fill: "#1A84DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8274 25.8622C12.2909 25.8622 13.4773 24.6823 13.4773 23.2268C13.4773 21.7713 12.2909 20.5913 10.8274 20.5913C9.36394 20.5913 8.17757 21.7713 8.17757 23.2268C8.17757 24.6823 9.36394 25.8622 10.8274 25.8622Z",
    fill: "#6D94CE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2183 25.8622C30.6818 25.8622 31.8682 24.6823 31.8682 23.2268C31.8682 21.7713 30.6818 20.5913 29.2183 20.5913C27.7549 20.5913 26.5685 21.7713 26.5685 23.2268C26.5685 24.6823 27.7549 25.8622 29.2183 25.8622Z",
    fill: "#F2CF63"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4773 14.7144H12.1092V19.9852H13.4773V14.7144Z",
    fill: "#1A84DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5042 14.7144H10.1361V19.9852H11.5042V14.7144Z",
    fill: "#1A84DD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54608 14.7144H8.17795V19.9852H9.54608V14.7144Z",
    fill: "#1A84DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4533 20.5913H18.0852V25.8622H19.4533V20.5913Z",
    fill: "#FE1D5B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4806 20.5913H16.1124V25.8622H17.4806V20.5913Z",
    fill: "#FE1D5B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5221 20.5913H14.1539V25.8622H15.5221V20.5913Z",
    fill: "#FE1D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaohaus);
export default __webpack_public_path__ + "static/media/daohaus.6e1b9b99794445cc2cf82b8b02e42460.svg";
export { ForwardRef as ReactComponent };